import events from '../../actions/event-names';
import Config from '../../config';
import { showError, showSuccess } from '../../utils'

const initialState = {
    isListFetchCompleted: false,
    isListFetched: false,
    assessmentTestList: [],
    isDetailsFetched: false,
    assessmentTestDetails: "",
};

export default function reducer(state = initialState, action) {
    switch (action.type) {
 
    //   LIST
    case `${events.GET_ENDURANCE_ACTIVITY_LIST}_PENDING`: {
        if(action.meta.page === 0) {
            state.assessmentTestList = [];
        }
        return {
            ...state,
            isListFetched: 'PENDING',
        };
    }
    case `${events.GET_ENDURANCE_ACTIVITY_LIST}_FULFILLED`: {
        if(action.payload.data.length === 0) {
            state.isListFetchCompleted = true;
        }
        return {
            ...state,
            assessmentTestList: [...state.assessmentTestList, ...action.payload.data],
            isListFetched: 'FULFILLED',
        };
    }
    case `${events.GET_ENDURANCE_ACTIVITY_LIST}_REJECTED`: {
        return {
            ...state,
            isListFetched: 'REJECTED',
        };
    }


    //   DETAILS
    case `${events.GET_ENDURANCE_ACTIVITY_DETAILS}_PENDING`: {
        return {
            ...state,
            assessmentTestDetails: "",
            isDetailsFetched: 'PENDING',
        };
    }
    case `${events.GET_ASSESSMENT_TEST_DETAILS_BG}_FULFILLED`: 
    case `${events.GET_ENDURANCE_ACTIVITY_DETAILS}_FULFILLED`: {
        return {
            ...state,
            assessmentTestDetails: action.payload.data,
            isDetailsFetched: 'FULFILLED',
        };
    }
    case `${events.GET_ENDURANCE_ACTIVITY_DETAILS}_REJECTED`: {
        return {
            ...state,
            isDetailsFetched: 'REJECTED',
        };
    }


    //  DETAILS SAVE
    case `${events.SAVE_ASSESSMENT_TEST_TRANSLATIONS}_PENDING`:
    case `${events.SAVE_ASSESSMENT_TEST_DETAILS}_PENDING`: {
        return {
            ...state,
            saveAssessmentTestDetails: 'PENDING',
        };
    }
    case `${events.SAVE_ASSESSMENT_TEST_TRANSLATIONS}_FULFILLED`:
    case `${events.SAVE_ASSESSMENT_TEST_DETAILS}_FULFILLED`: {
        showSuccess("Updated successfully")
        return {
            ...state,
            saveAssessmentTestDetails: 'FULFILLED',
        };
    }
    case `${events.SAVE_ASSESSMENT_TEST_TRANSLATIONS}_REJECTED`:
    case `${events.SAVE_ASSESSMENT_TEST_DETAILS}_REJECTED`: {
        return {
            ...state,
            saveAssessmentTestDetails: 'REJECTED',
        };
    }



    case `${events.ADD_NEW_ENDURANCE_CATEGORY}_PENDING`: {
        return {
            ...state,
            isNewEnduranceAdded: 'PENDING',
        };
    }
    case `${events.ADD_NEW_ENDURANCE_CATEGORY}_FULFILLED`: {
        showSuccess("New endurance category added successfully")
        return {
            ...state,
            isNewEnduranceAdded: 'FULFILLED',
        };
    }
    case `${events.ADD_NEW_ENDURANCE_CATEGORY}_REJECTED`: {
        return {
            ...state,
            isNewEnduranceAdded: 'REJECTED',
        };
    }


    case `${events.UPDATE_ENDURANCE_CATEGORY}_PENDING`: {
        return {
            ...state,
            idECUpdated: 'PENDING' + action.meta.id
        };
    }
    case `${events.UPDATE_ENDURANCE_CATEGORY}_FULFILLED`: {
        showSuccess("Updated successfully")
        return {
            ...state,
            idECUpdated: 'FULFILLED' + action.meta.id
        };
    }
    case `${events.UPDATE_ENDURANCE_CATEGORY}_REJECTED`: {
        return {
            ...state,
            idECUpdated: 'REJECTED' + action.meta.id
        };
    }


    case `${events.DELETE_ENDURANCE_CATEGORY}_PENDING`: {
        return {
            ...state,
            isECDeleted: 'PENDING' + action.meta.id
        };
    }
    case `${events.DELETE_ENDURANCE_CATEGORY}_FULFILLED`: {
        showSuccess("Deleted successfully")
        return {
            ...state,
            isECDeleted: 'FULFILLED' + action.meta.id
        };
    }
    case `${events.DELETE_ENDURANCE_CATEGORY}_REJECTED`: {
        return {
            ...state,
            isECDeleted: 'REJECTED' + action.meta.id
        };
    }

    case `${events.ADD_NEW_ASSESSMENT_TEST}_PENDING`: {
        return {
            ...state,
            isNewAssessmentTestAdded: 'PENDING',
        };
    }
    case `${events.ADD_NEW_ASSESSMENT_TEST}_FULFILLED`: {
        showSuccess("New assessment test added successfully")
        return {
            ...state,
            isNewAssessmentTestAdded: 'FULFILLED',
        };
    }
    case `${events.ADD_NEW_ASSESSMENT_TEST}_REJECTED`: {
        return {
            ...state,
            isNewAssessmentTestAdded: 'REJECTED',
        };
    }


    case `${events.DELETE_ASSESSMENT_TEST}_PENDING`: {
        return {
            ...state,
            isAssessmentTestDeleted: 'PENDING',
        };
    }
    case `${events.DELETE_ASSESSMENT_TEST}_FULFILLED`: {
        showSuccess("Assessment test deleted successfully")
        return {
            ...state,
            isAssessmentTestDeleted: 'FULFILLED',
        };
    }
    case `${events.DELETE_ASSESSMENT_TEST}_REJECTED`: {
        return {
            ...state,
            isAssessmentTestDeleted: 'REJECTED',
        };
    }
    

    






    default:
        return state;
    }
}
